import { BoletoService } from './boleto-service'
import { api } from '../../plugins/api'
export * from './boleto'
export * from './boleto-service'

export const boleto_service = new BoletoService(api)